import request from './request'

const API_ROOT = process.env.API_ROOT // 结算中心接口路径
const API_PL = process.env.API_PL

// 手机验证码发送
export function sendCode(params) {
    return request({
        url: API_ROOT + '/sms/sendCode',
        params: params,
        method: 'post'
    })
}

// 校验验证码
export function checkCode(params) {
    return request({
        url: API_ROOT + '/sms/checkCode',
        params: params,
        method: 'get'
    })
}

// 保存商场支付订单
export function savePayOrder(params) {
  return request({
      url: API_ROOT + '/shopOrder/create',
      params: params,
      method: 'post'
  })
}

// 注册
export function regwallet(params) {
    return request({
        url: API_ROOT + '/user/regwallet',
        params: params,
        method: 'post'
    })
}

// 用户登录
export function userLogin(params) {
    return request({
        url: API_ROOT + '/user/checkPhoneAndPwd',
        params: params,
        method: 'get'
    })
}

// 用户信息
export function userInfo(params) {
    return request({
        url: API_ROOT + '/user/info_id',
        params: params,
        method: 'get'
    })
}

// 忘记密码（修改密码）
export function changepasswd(params) {
    return request({
        url: API_ROOT + '/user/changepasswd',
        params: params,
        method: 'put'
    })
}

// 获取积分发放和绩效收益
export function listFundRecords(params) {
    return request({
        url: API_ROOT + '/user/listFundRecords',
        params: params,
        method: 'get'
    })
}

// 红包兑现比率
export function getRedRate() {
  return request({
      url: API_ROOT + '/cashpool/output/getRateOfRed',
      method: 'get'
  })
}

// Nbtc的价格
export function getNbtcPrice() {
  return request({
      url: API_ROOT + '/cashpool/output/getRateOfNbtc',
      method: 'get'
  })
}

// 兑换手续费率
export function getFeeRate() {
  return request({
      url: API_ROOT + '/cashpool/output/getCashFeeRate',
      method: 'get'
  })
}

// 兑换官方接收账户
export function getCashReceiveAddress() {
  return request({
      url: API_ROOT + '/cashpool/output/getCashReceiveAddress',
      method: 'get'
  })
}

/**
 * 获取审核情况
 * @param {*} txid
 * @returns
 */
export function getOneCash(txid) {
  return request({
    url: API_ROOT + '/cashpool/output/getByTxid',
    params: {
      txid: txid
    },
    method: 'get'
  })
}

// 提交积分兑现申请
export function applyCash(params) {
    return request({
        url: API_ROOT + '/cashpool/output/applyCash',
        params: params,
        method: 'post'
    })
}

// 提交兑现申请
export function applyCashPost(data) {
  return request({
      url: API_ROOT + '/cashpool/output/applyPost',
      data: data,
      method: 'post'
  })
}

// 提交积分兑现申请
export function cancelCash(txid) {
  return request({
      url: API_ROOT + '/cashpool/output/cancelCash',
      params: {txid},
      method: 'post'
  })
}

// 积分兑现列表
export function applyList(params) {
    return request({
        url: API_ROOT + '/cashpool/output/list',
        params: params,
        method: 'get'
    })
}

// 用户更改密码
export function updatepasswd(params) {
    return request({
        url: API_ROOT + '/user/updatepasswd',
        params: params,
        method: 'put'
    })
}

/**
* 用户绑定钱包收益地址
*/
export function bindWalletAccount(params) {
    return request({
        url: API_ROOT + '/useracocunt/create',
        params: params,
        method: 'post'
    })
}

/**
* 用户钱包收益地址
*/
export function userBindInfo(uid) {
    return request({
        url: API_ROOT + '/useracocunt/bindinfo',
        params: { uid },
        method: 'get'
    })
}

/**
* 查询用户业绩链分分配记录
*/
export function userPerformaceDetails(params) {
    return request({
        url: API_ROOT + '/user/userPerformaceDetails',
        params: params,
        method: 'get'
    })
}

/**
* 查询用户创业养老基金记录
*/
export function userPensionList(params) {
    return request({
        url: API_ROOT + '/user/userPensionList',
        params: params,
        method: 'get'
    })
}

/**
* 创业养老基金申请分发
*/
export function applyCyylFund(params) {
    return request({
        url: API_ROOT + '/user/applyCyylFund',
        params: params,
        method: 'get'
    })
}

/**
* 获取最新链分价值
*/
export function getLatestFundvalue() {
    return request({
        url: API_ROOT + '/fundValue/latest',
        method: 'get'
    })
}

/**
* 获取最新链分价值K线图
*/
export function loadValueKline(params) {
    return request({
        url: API_ROOT + '/fundValue/dayValue',
        params: params,
        method: 'get'
    })
}

/**
* 获取最新链分价值折线图
*/
export function loadValueLine(params) {
  return request({
      url: API_ROOT + '/fundValue/dayValueLine',
      params: params,
      method: 'get'
  })
}

/**
* 获取用户节点信息
*/
export function getUserNode(params) {
    return request({
        url: API_ROOT + '/nodes/userNode',
        params: params,
        method: 'get'
    })
}

/**
* 获取用户节点信息
*/
export function fundbalance(params) {
    return request({
        url: API_ROOT + '/chain/fundbalance',
        params: params,
        method: 'get'
    })
}

export function userNodes(params) {
    return request({
        url: API_ROOT + '/nodes/userNodes',
        params: params,
        method: 'get'
    })
}

export function nodesTerminate(id) {
  return request({
      url: API_ROOT + '/nodes/terminated/' + id,
      method: 'put'
  })
}

export function loadPayAccount() {
  return request({
    url: API_ROOT + '/chain/getPayAccount',
    method: 'get'
  })
}

// 监控平台API

export function summary() {
    return request({
        url: API_PL + '/block/summary',
        method: 'get'
    })
}

// 获取节点信息
export function getNode(ip) {
    return request({
        url: API_PL + '/peer/getNode',
        params: { ip },
        method: 'get'
    })
}

// 获取链分最新价值
export function getblockcount() {
    return request({
        url: API_PL + '/block/getblockcount',
        method: 'get'
    })
}

// 获取发行信息
export function gettxoutsetinfo() {
    return request({
        url: API_PL + '/block/gettxoutsetinfo',
        method: 'get'
    })
}

// 获取地址余额
export function getbalance(address) {
    return request({
        url: API_PL + '/address/getbalance',
        params: { address: address },
        method: 'get'
    })
}


// 提交错误日志
export function sendError(user, error) {
  return request({
      url: API_ROOT + '/errorLog/save',
      data: {
        userData: user,
        errorMessage: error,
        fromSystem: 'wallet-h5'
      },
      method: 'post'
  })
}

// 获取兑换商品
export function getExGoods(key) {
  return request({
      url: API_ROOT + '/exchange/goodsList',
      method: 'get',
      params: { key }
  })
}

// 创建兑换订单
export function createOrderEx(param) {
  return request({
      url: API_ROOT + '/exchange/createOrder',
      method: 'post',
      data: param
  })
}

// 获取兑换订单记录
export function getExOrders(param) {
  return request({
      url: API_ROOT + '/exchange/orderList',
      method: 'get',
      params: param
  })
}

// 完成订单支付
export function orderExPayment({ orderId, txId }) {
  return request({
      url: API_ROOT + '/exchange/payment',
      method: 'post',
      params: {
        orderId,
        txId
      }
  })
}

// 兑换订单列表
export function getExOrderList(param) {
  return request({
      url: API_ROOT + '/exchange/orderList',
      method: 'get',
      params: param
  })
}

// 兑换订单详情
export function getExOrderById(id) {
  return request({
      url: API_ROOT + '/exchange/getOrder/' + id,
      method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/service/http.js